import { clsx, type ClassValue } from "clsx";
import { DateTime as dayjs, ConfigType as DateInput } from "@/core/date/DateTime";
import { twMerge } from "tailwind-merge";

export function getCookie(name: string): string | null {
  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const [key, value] = cookie.trim().split("=");
    if (key === name) {
      return decodeURIComponent(value);
    }
  }
  return null;
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** backend katakana-validation と同じ。全角スペースは姓・名区切り（SAN）のみ許可 */
export function isAnyKatakana(text: string) {
  const segment = "[\u30A0-\u30FF\uFF65-\uFF9F]+";
  return new RegExp(`^${segment}(\u3000${segment})*$`).test(text);
}

export function showDateTime(date: DateInput) {
  return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
}
